module.exports = __webpack_public_path__ + "72d45b3c8c512d3e457d0caa0ed6086c.svg";